export const DataGrid = () => import('../../components/data-grid.vue' /* webpackChunkName: "components/data-grid" */).then(c => wrapFunctional(c.default || c))
export const Files = () => import('../../components/files.vue' /* webpackChunkName: "components/files" */).then(c => wrapFunctional(c.default || c))
export const MassReparsePeriod = () => import('../../components/mass-reparse-period.vue' /* webpackChunkName: "components/mass-reparse-period" */).then(c => wrapFunctional(c.default || c))
export const Signin = () => import('../../components/signin.vue' /* webpackChunkName: "components/signin" */).then(c => wrapFunctional(c.default || c))
export const Upload = () => import('../../components/upload.vue' /* webpackChunkName: "components/upload" */).then(c => wrapFunctional(c.default || c))
export const SystemLoading = () => import('../../components/system/loading.vue' /* webpackChunkName: "components/system-loading" */).then(c => wrapFunctional(c.default || c))
export const SystemModal = () => import('../../components/system/modal.vue' /* webpackChunkName: "components/system-modal" */).then(c => wrapFunctional(c.default || c))
export const TemplateButtons = () => import('../../components/template/buttons.vue' /* webpackChunkName: "components/template-buttons" */).then(c => wrapFunctional(c.default || c))
export const TemplateControl = () => import('../../components/template/control.vue' /* webpackChunkName: "components/template-control" */).then(c => wrapFunctional(c.default || c))
export const TemplateDatesHeader = () => import('../../components/template/dates-header.vue' /* webpackChunkName: "components/template-dates-header" */).then(c => wrapFunctional(c.default || c))
export const TemplateDates = () => import('../../components/template/dates.vue' /* webpackChunkName: "components/template-dates" */).then(c => wrapFunctional(c.default || c))
export const TemplateFileName = () => import('../../components/template/file-name.vue' /* webpackChunkName: "components/template-file-name" */).then(c => wrapFunctional(c.default || c))
export const TemplateStage = () => import('../../components/template/stage.vue' /* webpackChunkName: "components/template-stage" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
